import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ToolTypeRegistryService {
    private readonly toolTypeMap = new Map<string, string>();

    registerTools(tools: Array<{ tOOL_NAME: string; tOOL_TYPE: string }>): void {
        if (!tools || !Array.isArray(tools)) {
            return;
        }

        tools.forEach(tool => {
            const name = tool?.tOOL_NAME;
            const type = tool?.tOOL_TYPE;

            if (!name || !type) {
                return;
            }

            this.toolTypeMap.set(name.toLowerCase(), type);
        });
    }

    getType(toolName: string): string | null {
        if (!toolName) {
            return null;
        }

        const key = toolName.toLowerCase();

        return this.toolTypeMap.get(key) || null;
    }
}
